var bv_controller = {
    fingerprint_lib: 'https://cdn.jsdelivr.net/npm/@thumbmarkjs/thumbmarkjs/dist/thumbmark.umd.js',
    fingerprint: null,
    init: function(){
        if(
            typeof window.BV === 'undefined'
            || typeof window.BV.pixel === 'undefined'
        ){
            console.error('BV Pixel not loaded');
            return;
        }

        this.asked_consent();

        if(typeof bv_pixel_order != 'undefined'){ //Send our order data
            this.track_transaction(
                bv_pixel_order.order_id,
                bv_pixel_order.order_total,
                bv_pixel_order.order_items
            );
        }
    },
    track_transaction: function(order_id, order_total, order_items){
        canTrack = this.validate_items(order_items);
        if(!canTrack){
            console.error('Unable to send transaction');
            return;
        }
        window.BV.pixel.trackTransaction({
            orderId: order_id,
            total: order_total,
            items: order_items
        });
    },
    validate_items: function(items){
        items.forEach(function(item){
            if(
                typeof item.productId === 'undefined'
                || typeof item.price === 'undefined'
                || typeof item.quantity === 'undefined'
            ){
                console.error('Invalid item data');
                return false;
            }
        });

        return true;
    },
    track_page_view: function(){
        window.BV.pixel.trackPageView();
    },
    asked_consent: function(){
        return true;
        var asked = window.localStorage.getItem('bv_consent_asked');
        if(asked == 'true'){
            return true;
        }else{
            this.tracking_consent();
        }
    },
    tracking_consent: function(){

        //This is a functional consent process, but should be replaced with a more robust solution

        dialog_controller.display_dialog({
            title: 'Tracking Consent',
            content: 'Do you consent to tracking? (This is placeholder content and should be replaced, once all integrations are complete we may even replace with a platform level consent dialog)',
        }, [
            {
                text: 'Yes',
                callback: function(){
                    window.localStorage.setItem('bv_consent_asked', true);
                    dialog_controller.close_closest_dialog(this);
                },
            }, 
            {
                text: 'No',
                callback: function(){
                    window.BV.pixel.doNotTrack();
                    window.localStorage.setItem('bv_consent_asked', true);
                    dialog_controller.close_closest_dialog(this);
                },
                class: 'invert'
            }
        ]);
    },
    prep_fingerprint: function(){
        jQuery(document).trigger('bv_fingerprint_loading');
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = this.fingerprint_lib;
        script.onload = function(){
            ThumbmarkJS.getFingerprint().then(function(fingerprint){
                bv_controller.fingerprint = fingerprint;
                jQuery(document).trigger('bv_fingerprint_ready');
            });
        };
        document.head.appendChild(script);
    }
};

jQuery(document).ready(function(){
    bv_controller.init();
});

window.bv_controller = bv_controller;